module.exports = __webpack_public_path__ + "static/media/14.1f6c1ca8.jpg";